import React from 'react'
import UpdateProductionCostName from "./UpdateProductionCostName";
import UpdateProductionRatio from "./UpdateProductionRatio";
import UpdateProductionCostDelete from "./UpdateProductionCostDelete";

const UpdateProductionRows = ({id, row}) => {

    return(
        <React.Fragment>
            <tr>
                <td>{Number(id) + 1}</td>
                <td><UpdateProductionCostName row={row} id={id} /></td>
                <td> <UpdateProductionRatio row={row} id={id}/> </td>
                <td> <UpdateProductionCostDelete  id={id}/> </td>
            </tr>
        </React.Fragment>
    )
}
export default UpdateProductionRows